export default __webpack_public_path__ + "static/media/sprite.0d5b1d49.svg";